// ==============================|| Param api HOOKS ||============================== //

const useParamApi = () => {
    const handleQueryString = (name: string, param: any, chart: '?' | '&' = '&') => {
        return param ? `${chart}${name}=${param}` : '';
    };

    return {
        handleQueryString
    };
};

export default useParamApi;
